import {
  Box,
  Button,
  Flex,
  Heading,
  HStack,
  Icon,
  Image,
  Link,
  Text,
  VStack,
} from "@chakra-ui/react";
import styled from "@emotion/styled";
import { motion } from "framer-motion";
import React from "react";
import { FaGithub, FaJs, FaLinkedin, FaNodeJs, FaReact } from "react-icons/fa";
import {
  SiExpress,
  SiGit,
  SiMicrosoftsqlserver,
  SiMongodb,
  SiMysql,
  SiOracle,
  SiSqlite,
  SiTypescript,
} from "react-icons/si";

const AnimatedBox = styled(Box)`
  position: relative;
  &:before {
    content: "";
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    width: 4px;
    background: teal;
    transform: scaleY(0);
    transform-origin: top;
    transition: transform 0.3s ease;
  }
  &:hover:before {
    transform: scaleY(1);
  }
`;

const Section = ({ title, children }) => (
  <AnimatedBox
    as={motion.div}
    whileHover={{ scale: 1.05 }}
    whileTap={{ scale: 0.95 }}
    p={4}
  >
    <Heading as="h3" size="lg" mb={2}>
      {title}
    </Heading>
    {children}
  </AnimatedBox>
);

const About = () => {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 1 }}
    >
      <Flex direction="column" align="flex-start" py={10} px={6}>
        <Heading as="h2" size="xl" mb={4}>
          Sobre Mim
        </Heading>
        <Image
          borderRadius="full"
          boxSize="150px"
          src="https://avatars.githubusercontent.com/u/63386616?v=4"
          alt="Joabe Nascimento"
          mb={6}
          as={motion.img}
          initial={{ scale: 0.9 }}
          animate={{ scale: 1 }}
          transition={{ duration: 0.5 }}
        />
        <VStack spacing={4} align="flex-start">
          <Section title="Quem Sou">
            <Text fontSize="lg">
              Olá! Eu sou Joabe Nascimento, um Desenvolvedor Fullstack Pleno de
              Feira de Santana.
            </Text>
          </Section>
          <Section title="Trabalho Atual">
            <Text fontSize="lg">Desenvolvedor FullStack - Pleno</Text>
            <Text fontSize="lg">
              Suporte TI - (Suporte Sistemas) União Médica.
            </Text>
          </Section>
          <Section title="Experiência Anterior">
            <Text fontSize="lg">
              Trabalhei na Panificadora e Mercadinho Brito.
            </Text>
          </Section>
          <Section title="Formação">
            <Heading as="h4" size="md" mb={2}>
              Concluído
            </Heading>
            <Text fontSize="lg">Desenvolvimento de Sistemas - SENAI</Text>
            <Heading as="h4" size="md" mt={4} mb={2}>
              Em Andamento
            </Heading>
            <Text fontSize="lg">
              Análise e Desenvolvimento de Sistemas - UNIFAN
            </Text>
          </Section>
          <Section title="Paixão">
            <Text fontSize="lg">
              Tenho paixão por criar aplicações web modernas e responsivas.
            </Text>
          </Section>
          <Section title="Experiência Técnica">
            <Text fontSize="lg">Linguagens de Programação:</Text>
            <HStack pl={4}>
              <Icon as={FaJs} color="#f7df1e" boxSize={6} />
              <Text fontSize="lg">JavaScript</Text>
            </HStack>
            <HStack pl={4}>
              <Icon as={SiTypescript} color="#007acc" boxSize={6} />
              <Text fontSize="lg">TypeScript</Text>
            </HStack>
            <Text fontSize="lg" mt={4}>
              Bancos de Dados Relacionais:
            </Text>
            <HStack pl={4}>
              <Icon as={SiSqlite} color="#003b57" boxSize={6} />
              <Text fontSize="lg">SQLite</Text>
            </HStack>
            <HStack pl={4}>
              <Icon as={SiMicrosoftsqlserver} color="#cc2927" boxSize={6} />
              <Text fontSize="lg">SQL Server</Text>
            </HStack>
            <HStack pl={4}>
              <Icon as={SiOracle} color="#f80000" boxSize={6} />
              <Text fontSize="lg">OracleDB</Text>
            </HStack>
            <HStack pl={4}>
              <Icon as={SiMysql} color="#00758f" boxSize={6} />
              <Text fontSize="lg">MySQL</Text>
            </HStack>
            <Text fontSize="lg" mt={4}>
              Bancos de Dados Não Relacionais:
            </Text>
            <HStack pl={4}>
              <Icon as={SiMongodb} color="#47A248" boxSize={6} />
              <Text fontSize="lg">MongoDB</Text>
            </HStack>
            <Text fontSize="lg" mt={4}>
              Frameworks e Bibliotecas:
            </Text>
            <HStack pl={4}>
              <Icon as={FaReact} color="#61dafb" boxSize={6} />
              <Text fontSize="lg">React.js</Text>
            </HStack>
            <HStack pl={4}>
              <Icon as={FaNodeJs} color="#68a063" boxSize={6} />
              <Text fontSize="lg">Node.js</Text>
            </HStack>
            <HStack pl={4}>
              <Icon as={SiExpress} color="#000000" boxSize={6} />
              <Text fontSize="lg">Express.js</Text>
            </HStack>
            <HStack pl={4}>
              <Icon as={SiGit} color="#f05032" boxSize={6} />
              <Text fontSize="lg">Git</Text>
            </HStack>
            <HStack pl={4}>
              <Icon as={FaGithub} color="#181717" boxSize={6} />
              <Text fontSize="lg">GitHub</Text>
            </HStack>
            <HStack pl={4}>
              <Icon as={FaJs} color="#f7df1e" boxSize={6} />
              <Text fontSize="lg">Desenvolvimento de APIs</Text>
            </HStack>
          </Section>
        </VStack>
        <Link
          href="https://www.linkedin.com/in/joabe-nascimento-632345211/"
          isExternal
          mt={6}
        >
          <Button
            leftIcon={<Icon as={FaLinkedin} />}
            colorScheme="linkedin"
            variant="solid"
            mb={4}
          >
            Meu LinkedIn
          </Button>
        </Link>
        <Link
          href="https://www.linkedin.com/in/joabe-nascimento-632345211/details/certifications/"
          isExternal
          mt={6}
        >
          <Button
            leftIcon={<Icon as={FaLinkedin} />}
            colorScheme="linkedin"
            variant="outline"
          >
            Ver Certificados
          </Button>
        </Link>
      </Flex>
    </motion.div>
  );
};

export default About;
